import { useState, useEffect } from 'react';

/**
 * this hook used for checking an element that is onScreen or not
 *
 * import { useOnScreen } from @rabex-kit/core/hooks'
 *
 * @param ref
 * @returns
 */

export default function useOnScreen(ref: any, options?: any) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      options
    );
    ref.current && observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
}
